<template>
  <div class="table-wrapper">
    <TabulatorComponent
      v-if="evaluationPapers.length !== 0"
      v-model="evaluationPapers"
      :options="options"
      id="ResultTable"
    />
    <div v-else class="table-noresult">
      <p>{{ $t('PEER.ResultTable.noResult') }}</p>
    </div>
    <Modal v-if="isShow" />
  </div>
</template>

<script>
import { TabulatorComponent } from 'vue-tabulator';
import { getPaperData } from '@/api/index';
import Modal from '@/components/Modal.vue';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'ResultTable',
  components: {
    TabulatorComponent,
    Modal,
  },
  methods: {
    paperDataEditer(response) {
      const PapersLength = response.evaluationPapers.length;
      let papers = response.evaluationPapers;

      for (let paperNum = 0; paperNum < PapersLength; paperNum += 1) {
        let paper = papers[paperNum];
        paper.createdAt = this.convertToDate(paper.createdAt);
        paper.responseRate = this.responseRateCalculator(paper);
      }
      return papers;
    },
    convertToDate(milliseconds) {
      const createdDateObj = new Date(milliseconds);
      const createdDate = createdDateObj.toLocaleString().slice(0, -3);
      return createdDate;
    },
    responseRateCalculator(paper) {
      const currentNumberOfReviewers = paper.currentNumberOfReviewers;
      const totalNumberOfReviewers = paper.totalNumberOfReviewers;
      const responseRate = `(${currentNumberOfReviewers}/${totalNumberOfReviewers}) ${Math.round(
        (currentNumberOfReviewers / totalNumberOfReviewers) * 100
      )}%`;
      return responseRate;
    },
    ...mapActions('modal', ['AC_MODAL_OPEN']),
    resetSelectedResultId() {
      const content =
        this.$i18n.locale === 'eng'
          ? 'Evaluation sheet with a response rate of less than 70% are not eligible for a detailed lookup.'
          : '응답 비율이 70% 미만인 평가지는 상세 조회를 할 수 없습니다.';
      this.AC_MODAL_OPEN({
        content: content,
      });
      this.$emit('updateSelectedResultId', 0);
    },
  },
  computed: {
    ...mapState('modal', ['isShow']),
  },
  created() {
    getPaperData().then((response) => {
      const editedPapers = this.paperDataEditer(response);
      this.evaluationPapers = editedPapers;
    });
  },
  data() {
    return {
      evaluationPapers: [],
      options: {
        selectable: 1,
        columns: [
          {
            title: this.$i18n.locale === 'eng' ? 'Created at' : '평가 날짜',
            field: 'createdAt',
            sorter: 'string',
            width: '33.3%',
          },
          {
            title: this.$i18n.locale === 'eng' ? 'Title of sheet' : '평가지 이름',
            field: 'title',
            sorter: 'string',
            width: '33.3%',
          },
          {
            title: this.$i18n.locale === 'eng' ? 'Response rate' : '응답 비율',
            field: 'responseRate',
            sorter: 'string',
            width: '33.3%',
          },
        ],
        rowSelected: (row) => {
          this.$emit('updateCurrentNumberOfReviewers', row._row.data.currentNumberOfReviewers);
          this.$emit('updateSelectedResultId', row._row.data.evaluationPaperId);
        },
      },
    };
  },
  watch: {
    '$i18n.locale': function (newLocale, oldLocale) {
      this.options.columns[0].title = newLocale === 'eng' ? 'Created at' : '평가 날짜';
      this.options.columns[1].title = newLocale === 'eng' ? 'Title of sheet' : '평가지 이름';
      this.options.columns[2].title = newLocale === 'eng' ? 'Response rate' : '응답 비율';
    },
  },
};
</script>

<style lang="scss">
.table-wrapper {
  margin: 20px 0;
}
.table-noresult {
  height: 200px;
  margin: 30px 0;
  border: 2px solid $MAIN-COLOR;
  border-radius: 10px;
  font-size: 1.2rem;
  font-weight: bold;
  text-align: center;

  p {
    line-height: 200px;
  }
}
#ResultTable {
  box-sizing: border-box;
  max-width: 1200px;
  margin: 30px auto 0px auto;
  border-top: 2px solid $MAIN-COLOR;
  border-bottom: 2px solid $MAIN-COLOR;
  border-collapse: collapse;
  table-layout: fixed;

  .tabulator-header {
    border-bottom: 2px solid $MAIN-COLOR;
    border-top: none;
  }

  .tabulator-col.tabulator-sortable {
    background-color: #f4f3ef;
  }

  .tabulator-row.tabulator-selected {
    background-color: $SUB-COLOR;
  }
}

@media (max-width: 992px) {
  #ResultTable {
    width: 100%;
  }
}
</style>
